/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import { APICore } from '@/utils/servicesApi'


export function loginAgentStored(data) {
  return requestRaw({
    url: APICore() + '/sign-agent/login/stored',
    method: 'POST',
    data: data, // untuk array data post
    silent: true
  })
}

// const qs = require('qs')
export function loginMemberValidation(data) {
  return requestRaw({
    url: APICore() + '/member/login/validation',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function loginMemberStored(data) {
  return requestRaw({
    url: APICore() + '/member/login/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function getProfile() {
  return requestRaw({
    url: APICore() + '/member/account/profile',
    method: 'GET',
    // data: data // untuk array data post
  })
}

// Verifikasi token impersonation dengan memuat profil tanpa memicu redirect
// global 401 (silent). Dipakai halaman handoff sebelum pindah ke dashboard.
export function verifyImpersonationProfile() {
  return requestRaw({
    url: APICore() + '/member/account/profile',
    method: 'GET',
    silent: true
  })
}


export function getBank() {
  return requestRaw({
    url: APICore() + '/member/account/bank',
    method: 'GET',
    // data: data // untuk array data post
  })
}


export function getBankList() {
  return requestRaw({
    url: APICore() + '/member/account/bank_list',
    method: 'GET',
    // data: data // untuk array data post
  })
}

export function logout() {
  return requestRaw({
    url: APICore() + '/member/account/logout',
    method: 'GET',
    // data: data // untuk array data post
  })
}

// Menukar kode handoff sekali pakai (dari ZEUS) dengan access token member.
// Kode dikirim di body, bukan di query string.
export function exchangeMemberHandoff(data) {
  return requestRaw({
    url: APICore() + '/member/auth/handoff',
    method: 'POST',
    data: data,
    silent: true
  })
}

// Mengakhiri sesi impersonation (me-revoke token member impersonation).
export function endMemberImpersonation() {
  return requestRaw({
    url: APICore() + '/member/auth/impersonation/end',
    method: 'POST',
    data: {},
    silent: true,
    timeout: 10000
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js